module.exports = __webpack_public_path__ + "static/img/transitionBg1.a04e5d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/transitionBg1.png
// module id = wpqy
// module chunks = 1